// extracted by mini-css-extract-plugin
export default {"priceCardTab":"_3hQ6z","radio":"_2FrPf","tabInfo":"_3jGxf","ml0":"_2EAUd"};